import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: 'AIoT là gì, khái niệm, ứng dụng và phân loại ra sao, mang lại lợi ích gì cho doanh nghiệp cũng như đời sống con người, và tại sao nó lại trở thành xu hướng dẫn đầu trong kỷ nguyên công nghệ? Hãy cùng ORBRO khám phá trong bài viết dưới đây.',
  keywords: 'aiot, aiot là gì, ai, iot, ứng dụng aiot',
  ogSite: 'AIoT là gì? Khái niệm, ứng dụng và phân loại',
  title: 'AIoT là gì? Khái niệm, ứng dụng và phân loại',
  ogUrl: 'https://orbro.io/vi/blog/aiot-la-gi-khai-niem-ung-dung-va-phan-loai',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_GLbm0ePZyDdFCNthass1IlM-Z3nupHwFJSKWqDdS628SvJQwhL3N50vF3RP0vtCGWJGaWugWAl7r4wUDP14c_ehNlkierxfmUA_iUEgMIGveAknIaaCXVeYISKsoJGmzLv4g8BsiWFq5MypclSqKcrFR5_qQafKT4FcgNRVa4ll8OI2kCfSi3_RmTSgFBqilTLuNCmRHvtPgSZjcuRcIf7lf8LVJWtZlNBjmASJe2oIW2Na_ZLxUzwq9KcNIabo5Yac9khP2FSZ-lfJc-FuGqp4qED7tPR_GECiJxrkKyT51yqWCFCAYONF3tW5ApGQocY2Y0j8Wt8JYGA2T4auUomFZ-2YexvOVIr9gtxSoahEmZs3aqd5lecS9UZASgpHYmbGUsfAC2RCKY0kABl6fOwWmcra_Akg0Dqe_fEAk0TJnyHBkRu-OfROo-RkuBXaYyTVNHyQce5CCYQC2-NeJKoXjPi1Hx4vplT6-TunG0YEFM-ahJ2HyKb6NGqEPWMn-ydwljQLD2BGiOaKM-kHBwgRCZI8gbyt_ah0gcHd-kSv07fFtUQOXyRo1E-5jw9zKGzeoSSrHa4aHRgZMIR86-tKaWxPhaR7cA6xUbtZb8e0u-Vt7q_HpkytUEBKMXMowS4otwjFasekh7QHB4aALif7DZTWP7RtntuRgaDqWwuSV64ys2WbkTmMJTGg2lUDIQMakBfxYHRpaySzxYpzx_Vy4ktVTutRRRffGPDYueOQeLUIf1qWyjjYGwv3fK7SpH9cdUj01-wRen-XrD87VWzhTnQzDwpx2wHFpyFas0IXhXRi4bShyh1E3EU1UDkyLQBSlK3CaPWNEdjGKnF190RR0GB8YTK8FMNwaVVV4chqmCmCrk8EkzrMPmgpeELBBsaUi0pDu58E3iSwrfm-wgHXYiRRqfcnETgdE7y2WmRuUePqZ-LaB_Cr9RNhqFmgUyhHLqGDD8I6dOvAYPEhm3ju3SykrbyPUHX4VRxTmrb87IE--KLrfHkYHGl9rswrVUMyOWI8hTPVmf2nguYRzDvED6lgkw-Eu26EaLLEU6hUzl5Kg8ztvQLuIspuYVTH0vmpCrE9bjo0rrUBiyskMDk0XyVkfFfdtuvpEUQeiQ59qI-5zlX7FX-sLnST6PWPq-55wE8gzyyW6vkpVoDSfWNnwc4uf4k1E6ah644lpR-PuxeEaSSUI61g1D_dx26FpY6fXt076r_U6_9oJQ9_BjOKdqstxYDLOqXJIIOL4Cw7IOo8ZUcauXXClxz4iQCDPLdcNLF7RVETp_s1MfLbRsz5aTm4ltIJdBYz5Yk572Sr38S6Dq1_gScSjwVbOAGPhx2wKCs6CGalrnFS9fHzB_Hq19dfe6sdCqC6nRilHSxnnxp3SMniIKw1q-nd9_PK0Fx03ldozYG9NKeOSCYUIGYIvAYsIi295GW0umLVsmA3tcfTmnYhM3s14Knp0S_ZIEAPZYuWFodcUE7hbfaP6_GaCwXepfrCGpU_td0aD-z6p3LG_fSIKkBb6FiI05vuCqEU0iTTldofMpGL2ZsKhZFw1m7aWpjBF40wLrW1k2CW5y3lmpMU4Z33NrHpafaP_BTipI2vTAGh2GL38_LIjcMo9sJqqT7Bi1K=w1430-h1412?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-08',
  tag1: '#aiot',
  tag2: '#ai',
  tag3: '#iot',
  tag4: '#trituenhantao',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Trong thời đại Công nghiệp 4.0, nhu cầu kết nối mọi thiết bị và biến dữ liệu thô thành hành động thông minh ngày càng gia tăng. Chính vì thế, khái niệm AIoT (Artificial Intelligence of Things) – sự hòa quyện giữa Trí tuệ nhân tạo (AI) và Internet vạn vật (IoT)  đã ra đời. AIoT không chỉ mang lại khả năng thu thập dữ liệu từ cảm biến, mà còn cho phép phân tích sâu sắc, tự động hóa và tối ưu hóa quy trình một cách tinh vi. Từ nhà máy thông minh đến thành phố thông minh, AIoT đang mở ra một kỷ nguyên mới cho doanh nghiệp và cộng đồng.\n\nVậy AIoT là gì, khái niệm, ứng dụng và phân loại ra sao, mang lại lợi ích gì cho doanh nghiệp cũng như đời sống con người, và tại sao nó lại trở thành xu hướng dẫn đầu trong kỷ nguyên công nghệ? Hãy cùng ORBRO khám phá trong bài viết dưới đây.',
      dot: ''
    },
    {
      head: '1. AIoT là gì?',
      subHead: '',
      desc: 'AIoT (Artificial Intelligence of Things) là sự kết hợp giữa trí tuệ nhân tạo (AI) và Internet vạn vật (IoT):\n\n• IoT: Hệ sinh thái các thiết bị, cảm biến, máy móc được kết nối Internet, thu thập dữ liệu về môi trường, quy trình, trạng thái hoạt động.\n\n• AI: Khả năng phân tích, học hỏi từ dữ liệu và đưa ra dự đoán hoặc hành động tự động.\n\nKhi IoT thu thập dữ liệu khổng lồ, AI sẽ xử lý để tìm ra mẫu, xu hướng và đưa ra quyết định theo thời gian thực. Ví dụ, trong nhà máy, cảm biến IoT đo nhiệt độ và độ rung của động cơ, AI sẽ phân tích để dự báo hỏng hóc trước khi sự cố xảy ra, và đó chính là sức mạnh của AIoT.',
      dot: ''
    },
    {
      head: '2. Ứng dụng thực tiễn của AIoT',
      subHead: 'Sản xuất thông minh (Smart Manufacturing)',
      desc: 'Bảo trì dự đoán: Cảm biến IoT giám sát rung động, nhiệt độ, dầu bôi trơn; AI phân tích giúp kỹ thuật viên lên lịch bảo trì trước khi máy móc gặp sự cố.\n\nTối ưu hóa chuỗi cung ứng: AI tự động điều phối vật tư dựa trên dữ liệu tồn kho và đơn hàng, giảm thời gian chờ và chi phí lưu kho.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Thành phố thông minh (Smart City)',
      desc: 'Quản lý đèn đường thông minh: IoT đo lưu lượng giao thông, AI phân tích để tự động điều chỉnh độ sáng và tiết kiệm điện vào giờ thấp điểm.\n\nGiám sát ô nhiễm: Cảm biến không khí liên tục gửi dữ liệu, AI dự báo đợt ô nhiễm cao để cơ quan chức năng cảnh báo người dân.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Giao thông và logistics',
      desc: 'Xe tự lái và hỗ trợ lái: Camera, radar kết nối IoT, AI xử lý dữ liệu hình ảnh và cảm biến để tránh va chạm và tối ưu lộ trình.\n\nTheo dõi kho bãi: RFID và cảm biến IoT biết chính xác vị trí pallet, AI dự đoán điểm nghẽn và đề xuất bố trí lại.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Y tế và chăm sóc sức khỏe',
      desc: 'Theo dõi bệnh nhân từ xa: Thiết bị đeo IoT thu thập nhịp tim, huyết áp; AI phân tích cảnh báo bác sĩ khi chỉ số bất thường.\n\nQuản lý dược phẩm: Hệ thống tủ thuốc IoT tự động kiểm kiểm tồn kho, AI đề xuất bổ sung khi lượng thuốc sắp hết.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Nông nghiệp thông minh (Smart Agriculture)',
      desc: 'Tưới tiêu tự động: Cảm biến độ ẩm đất và cảm biến thời tiết IoT, AI phân tích lượng nước tối ưu, tiết kiệm 30–50% nước tưới.\n\nGiám sát mùa vụ bằng drone: Drone thu thập hình ảnh, AI phân tích dấu hiệu sâu bệnh và đưa ra biện pháp chăm sóc kịp thời.',
      dot: ''
    },
    {
      head: '3. Phân loại AIoT',
      subHead: '',
      desc: 'AIoT không “one-size-fits-all” mà đa dạng theo nhu cầu và mô hình triển khai như:',
      dot: ''
    },
    {
      head: '',
      subHead: 'Theo vị trí xử lý dữ liệu',
      desc: 'Edge AIoT: Xử lý dữ liệu ngay tại biên mạng (edge device) để giảm độ trễ, phù hợp ứng dụng realtime như xe tự lái, robot.\n\nCloud AIoT: Đưa dữ liệu lên nền tảng đám mây để phân tích phức tạp, phù hợp ứng dụng cần sức mạnh tính toán lớn.\n\nHybrid AIoT: Kết hợp edge và cloud để cân bằng giữa tốc độ và sức mạnh phân tích.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Theo mức độ tích hợp',
      desc: 'AI hỗ trợ IoT: AI chủ yếu dùng để phân tích báo cáo từ hệ thống IoT.\n\nIoT nâng tầm AI: Hệ thống AI mạnh, IoT chỉ cung cấp dữ liệu thô.\n\nAIoT toàn diện: Tích hợp sâu, AI và IoT cộng sinh trong mọi khâu từ thu thập đến phản hồi.',
      dot: ''
    },
    {
      head: '4. Lợi ích khi áp dụng AIoT',
      subHead: '',
      desc: 'Tự động hóa thông minh: Giảm thiểu tác vụ thủ công, tập trung nhân lực vào việc sáng tạo.\n\nRa quyết định nhanh chóng: Dữ liệu thời gian thực và phân tích AI giúp phản ứng kịp thời với thay đổi.\n\nTiết kiệm chi phí: Giảm thời gian chết, tối ưu nguyên vật liệu và năng lượng.\n\nNâng cao chất lượng: Kiểm soát chặt chẽ quy trình sản xuất, phát hiện lỗi sớm.\n\nTrải nghiệm người dùng tốt hơn: Dịch vụ cá nhân hóa, chủ động thông báo và hỗ trợ.',
      dot: ''
    },
    {
      head: '5. Triển khai AIoT: Lưu ý thực tế',
      subHead: '',
      desc: 'Đánh giá hạ tầng: Kiểm tra mạng, cảm biến và khả năng mở rộng của hệ thống.\n\nĐảm bảo bảo mật: Mã hóa dữ liệu, kiểm soát truy cập và tuân thủ tiêu chuẩn GDPR/ISO.\n\nChọn nền tảng phù hợp: Cloud hay edge, SDK hay nền tảng nền tảng IoT có AI.\n\nĐào tạo nhân lực: Kết hợp chuyên gia AI, kỹ sư IoT và bộ phận vận hành.\n\nBắt đầu từ bài toán cụ thể: Triển khai thí điểm (pilot project) trước khi mở rộng.',
      dot: ''
    },
    {
      head: '6. Kết luận',
      subHead: '',
      desc: 'AIoT không chỉ là xu hướng mà đã trở thành “chìa khóa” để doanh nghiệp chinh phục kỷ nguyên số. Sự kết hợp giữa thu thập dữ liệu từ IoT và phân tích thông minh từ AI mang lại hiệu suất, độ linh hoạt và khả năng đổi mới vượt trội. Hãy bắt đầu hành trình AIoT của bạn ngay hôm nay để tạo ra lợi thế cạnh tranh và phát triển bền vững trong tương lai cùng với ORBRO.',
      dot: ''
    }
  ],
  
 link: {
   page: 'rtls',
   numb: '2',
   product: [
     {
       text: productPurchase.purchase.worker.workerTracking.title,
       title: productPurchase.purchase.worker.workerTracking.title,
       serial: productPurchase.purchase.worker.workerTracking.serial,
       desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
       img: productImg.product.workerTracking.thumbnail,
     },
     {},
   ],
   solution: [
     {
       img: constructionAsset.thumb,
       data: 'constructionAsset',
       link: '/vi/enterprise/construction/asset',
     },
     {
       img: constructionSafety.thumb,
       data: 'constructionSafety',
       link: '/vi/enterprise/construction/safety',
     },
     {
       img: logisticsAsset.thumb,
       data: 'logisticsAsset',
       link: '/vi/enterprise/logistics/asset',
     },
   ],
 },
}; 